<div class="product-form-page">
    <div class="btn-back-detail" (click)="cancel()">
        <i class="fal fa-arrow-left"></i>
        <span>Ver todos los productos</span>
    </div>

    <div *ngIf="!loaded" class="loading-container">
        <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
            containerClass="loading-box"></ng-lottie>
    </div>

    <form *ngIf="loaded" [formGroup]="form" (ngSubmit)="save()" class="form-layout">
        <!-- Left column: Form -->
        <div class="form-column">
            <div class="form-card">
                <div class="card-header">
                    <i class="fal fa-cart-shopping card-icon"></i>
                    <div>
                        <h2>Datos del producto</h2>
                        <p class="card-subtitle">Nombre y precio del alta o renovación del abono</p>
                    </div>
                </div>

                <div class="form-field">
                    <label class="field-label">NOMBRE</label>
                    <input type="text" formControlName="name" placeholder="Ej: Abono General">
                </div>

                <div class="form-field" style="margin-top: 16px; max-width: 220px;">
                    <label class="field-label">PRECIO (€)</label>
                    <input type="number" step="0.01" min="0" formControlName="price" placeholder="150.00">
                </div>

                <div class="form-field" style="margin-top: 16px;">
                    <label class="field-label">IMAGEN</label>

                    <div class="image-uploader" *ngIf="!imagePreview">
                        <input type="file" id="product-image" class="image-input"
                            accept="image/jpeg,image/png,image/webp" (change)="onImageSelected($event)">
                        <label for="product-image" class="image-dropzone">
                            <i class="fal fa-arrow-up-from-bracket"></i>
                            <span class="image-dropzone-text">Subir imagen</span>
                            <span class="image-dropzone-hint">JPG, PNG o WEBP · máx. 2 MB</span>
                        </label>
                    </div>

                    <div class="image-preview" *ngIf="imagePreview">
                        <img [src]="imagePreview" alt="Imagen del producto">
                        <button type="button" class="btn-remove-image" (click)="removeImage()">
                            <i class="fal fa-trash-can"></i> Quitar imagen
                        </button>
                    </div>

                    <span class="field-hint">
                        <i class="fal fa-info-circle"></i> Opcional.
                    </span>
                </div>
            </div>

            <div class="form-card" *ngIf="isEdit">
                <div class="card-header">
                    <i class="fal fa-calendar-range card-icon"></i>
                    <div>
                        <h2>Temporadas</h2>
                        <p class="card-subtitle">Dónde se puede comprar este producto</p>
                    </div>
                </div>

                <div class="linked-seasons" *ngIf="linkedSeasonNames.length > 0">
                    <span class="season-chip" *ngFor="let name of linkedSeasonNames">{{name}}</span>
                </div>

                <p class="field-hint" *ngIf="linkedSeasonNames.length === 0">
                    <i class="fal fa-info-circle"></i>
                    Este producto todavía no está en ninguna temporada.
                </p>

                <span class="field-hint">
                    <i class="fal fa-info-circle"></i>
                    Los productos se asignan desde la ficha de cada temporada.
                </span>
            </div>
        </div>

        <!-- Right column: Actions -->
        <div class="preview-column">
            <div class="channel-toggle-bar" [class.admin-only]="form.get('admin_only')?.value">
                <div class="channel-toggle-info">
                    <i class="fal" [ngClass]="form.get('admin_only')?.value ? 'fa-lock' : 'fa-globe'"></i>
                    <div>
                        <span class="channel-toggle-label">{{ form.get('admin_only')?.value ? 'Solo panel' : 'Web y panel' }}</span>
                        <span class="channel-toggle-hint">{{ form.get('admin_only')?.value
                            ? 'No aparece en el alta ni en la renovación web; solo se puede usar desde el panel.'
                            : 'Cualquier abonado puede elegirlo al darse de alta o renovar por su cuenta.' }}</span>
                    </div>
                </div>
                <mat-slide-toggle class="toggle-pink" formControlName="admin_only" color="primary"></mat-slide-toggle>
            </div>

            <div class="form-actions">
                <button type="submit" class="btn-save" [disabled]="!canSave">
                    <i class="fal" [ngClass]="saving ? 'fa-spinner-third fa-spin' : 'fa-floppy-disk'"></i>
                    {{ saving ? 'Guardando...' : (isEdit ? 'Guardar cambios' : 'Crear producto') }}
                </button>
                <button type="button" class="btn-cancel" (click)="cancel()">
                    Cancelar
                </button>
            </div>
        </div>
    </form>
</div>
